import {
  tpEvent,
  openWeb,
  tpDurationFetch,
  loadTrace,
  tpDurationLoad,
  closeWeb
} from './index'

/**---------------------埋点需求----------- */
export function loadTraceIframe(props = {}) {
  try {
    const start = new Date().getTime();
    // 点击事件埋点
    tpEvent({ ...props, start })

    // 刷新页面/打开新窗口/登录等操作
    window.addEventListener('load', function (e) {
      const oldTrace = sessionStorage.getItem('oldTrace')

      setTimeout(() => {
        // 启动应用
        openWeb({ ...props, start })
      }, 1000)

      // 先执行上个页面的停留埋点
      if (oldTrace) {
        tpDurationFetch({ ...props, start })
      }
      // 执行路由埋点
      loadTrace({ ...props, start })

      // 执行应用停留
      setTimeout(() => {
        tpDurationLoad({ ...props, start })
      }, 1000)

    });


    window.addEventListener('unload', function (e) {
      // 关闭应用
      closeWeb({ ...props, start })
    });

  } catch (err) {
    console.log(err, '埋点错误')
  }
}



// WEBPACK FOOTER //
// ./src/tf-traceService/iframe.js